<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Lei Comentada</h1>
                                    <p class="modern-subtitle">As Leis 14.133/21, 13.303/06 e 8.666/93 comentadas com doutrinas, acórdãos, links de conteúdo, artigos, vídeos e comentários exclusivos.</p>
                                </div>
                                <div class="header-actions">
                                    <ManualFerramenta :name="'Manual Lei Comentada'"
                                                      :btnClass="'btn-manual-tool'"
                                                      :nameBtn="'Manual'"
                                                      :urlPdf="'/manuais/FERRAMENTA LEI COMENTADA.pdf'" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="page-container">
                        <div class="search-card">
                            <div class="search-box">
                                <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                                <input type="text"
                                       class="modern-search-input"
                                       ref="dsTermo"
                                       placeholder="Pesquise por lei, decreto ou termo…"
                                       aria-label="Pesquisa principal"
                                       v-model="pesquisa.dsTermo"
                                       @keydown.enter="buscar" />
                            </div>

                            <button class="modern-btn modern-btn-primary btn-buscar" @click="buscar">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                                Buscar legislações
                            </button>
                        </div>

                        <div class="results-section">
                            <div class="results-header">
                                <h2 class="results-title">Legislações comentadas</h2>
                                <span class="results-query" v-if="!flCarregando">
                                    {{ pesquisa.dsTermo ? '"' + pesquisa.dsTermo + '"' : 'Todas as legislações' }}
                                </span>
                            </div>

                            <div v-if="flCarregando" class="empty-state empty-state--compact">
                                <div class="empty-content">
                                    <h3 class="empty-title">Carregando legislações…</h3>
                                    <p class="empty-description">Buscando os registros da Lei Comentada.</p>
                                </div>
                            </div>

                            <div v-else-if="lstResultados.length === 0" class="empty-state empty-state--compact">
                                <div class="empty-content">
                                    <h3 class="empty-title">Nenhum registro encontrado</h3>
                                    <p class="empty-description">Nenhum resultado para esta pesquisa.</p>
                                </div>
                            </div>

                            <div v-else class="cards-list">
                                <div class="result-card"
                                     v-for="(item, index) in lstResultados"
                                     :key="item.idLegislacao || index"
                                     role="button"
                                     tabindex="0"
                                     @click="abrirLegislacao(item)"
                                     @keydown.enter.prevent="abrirLegislacao(item)">
                                    <div class="result-card__body">
                                        <div class="result-card__meta">
                                            <span class="result-card__icon" aria-hidden="true">
                                                <i class="far fa-newspaper"></i>
                                            </span>
                                            <span class="result-badge">{{ rotuloTipo(item.tipo) }}</span>
                                        </div>
                                        <h3 class="result-card__title">{{ item.nome }}</h3>
                                        <p class="result-card__text" v-if="textoDescricao(item.descricao)">
                                            {{ textoDescricao(item.descricao) }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modais></Modais>

        <div class="modal fade modal-lei-comentada" tabindex="-1" id="ModalLeiComentada" ref="modalLeiComentada">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content border-0 bg-transparent">
                    <div class="md-wrapper" v-if="legislacaoSelecionada">
                        <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                                type="button"
                                aria-label="Fechar"
                                @click="fecharLegislacao">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg>
                        </button>

                        <div class="md-header" :class="{ rolou: rolou }">
                            <div class="md-header__id">
                                <span class="md-header__badge">
                                    <i class="far fa-newspaper"></i>
                                    {{ rotuloTipoCompleto(legislacaoSelecionada.tipo) }}
                                </span>
                                <h2 class="md-header__title">{{ tituloExibido }}</h2>
                            </div>
                        </div>

                        <div class="md-body" ref="corpoModalLei" @scroll="onScrollCorpo">
                            <div class="md-loading" v-if="flCarregandoDetalhe">
                                <div class="md-loading__spinner"></div>
                                <span>Carregando conteúdo…</span>
                            </div>

                            <div class="md-notfound" v-else-if="!detalheLegislacao">
                                <strong>Nenhum conteúdo encontrado</strong>
                                <p>Nenhum conteúdo encontrado para este item.</p>
                            </div>

                            <div class="viewLGFED" v-else-if="detalheLegislacao">
                                <div class="modal-conteudo">
                                    <div id="divImprimir" ref="divImprimir" v-if="detalheLegislacao.legislacao">
                                        <h3>{{ detalheLegislacao.legislacao.nmTitulo }}</h3>
                                        <p class="subtituloLei"
                                           v-if="detalheLegislacao.legislacao.dsLegislacao"
                                           v-html="detalheLegislacao.legislacao.dsLegislacao.replace('\r\n','<br />')"></p>
                                        <div class="aparato-resumo" v-if="detalheLegislacao.flExibeLeiComentada && totalAnotacoes">
                                            <span class="selo" v-if="totalNotas"><i class="i-nota"></i> {{ totalNotas }} anotações</span>
                                            <span class="selo" v-if="totalReg"><i class="i-reg"></i> {{ totalReg }} regulamentações</span>
                                        </div>
                                        <div id="htmlLegislacao" ref="htmlLegislacao" @click="handleClick" @keydown="handleClick"></div>
                                    </div>
                                </div>
                                <div class="d-none" id="conteudoImprimir" ref="conteudoImprimir"></div>
                                <div class="modal-footer">
                                    <p class="origem" v-if="detalheLegislacao.legislacao">{{ detalheLegislacao.legislacao.nmTitulo }}</p>
                                    <div class="acoes">
                                        <button class="btn-imprimir" type="button" @click="imprimir">
                                            Imprimir
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import axios from 'axios'
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import { urlApi, avisoErro } from '@/config/global'
    import ManualFerramenta from '@/components/Ferramentas/ManualFerramenta'

    const ICONES_ANOTACAO = {
        1: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>',
        2: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><path d="M15 3h6v6"/><path d="M10 14L21 3"/></svg>',
        3: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>',
        4: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>',
    }
    const ICONE_BALANCA = '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v18"/><path d="M5 7h14"/><path d="M5 7l-2.5 6a3.5 3.5 0 0 0 5 0z"/><path d="M19 7l2.5 6a3.5 3.5 0 0 1-5 0z"/></svg>'
    const ICONE_SETA = '<svg class="seta" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>'
    const ICONE_EXTERNO = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><path d="M15 3h6v6"/><path d="M10 14L21 3"/></svg>'
    const ICONE_DOWNLOAD = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M7 10l5 5 5-5"/><path d="M12 15V3"/></svg>'

    export default defineComponent({
        name: 'LeiComentada',
        components: {
            Header,
            Modais,
            ManualFerramenta
        },

        data() {
            return {
                pesquisa: {
                    dsTermo: '',
                },
                lstResultados: [],
                idLogPesquisa: null,
                flCarregando: false,
                flCarregandoDetalhe: false,
                legislacaoSelecionada: null,
                detalheLegislacao: null,
                modalLeiComentada: null,
                rolou: false,
            }
        },

        computed: {
            tituloExibido() {
                const lei = this.detalheLegislacao && this.detalheLegislacao.legislacao && this.detalheLegislacao.legislacao.nmTitulo
                return lei || (this.legislacaoSelecionada && this.legislacaoSelecionada.nome) || ''
            },
            totalReg() {
                return (this.detalheLegislacao && this.detalheLegislacao.legislacaoAnotacao || []).filter(a => a.flRegulamentacao === 'Sim').length
            },
            totalNotas() {
                return (this.detalheLegislacao && this.detalheLegislacao.legislacaoAnotacao || []).length - this.totalReg
            },
            totalAnotacoes() {
                return (this.detalheLegislacao && this.detalheLegislacao.legislacaoAnotacao || []).length
            },
        },

        methods: {
            onScrollCorpo(e) {
                this.rolou = e.target.scrollTop > 70
            },

            fecharLegislacao() {
                this.modalLeiComentada?.hide()
            },

            abrirLegislacao(item) {
                this.legislacaoSelecionada = item
                this.detalheLegislacao = null
                this.flCarregandoDetalhe = true
                this.rolou = false
                this.$nextTick(() => {
                    if (!this.modalLeiComentada && this.$refs.modalLeiComentada) {
                        this.modalLeiComentada = new window.bootstrap.Modal(this.$refs.modalLeiComentada)
                    }
                    this.modalLeiComentada?.show()
                    this.carregarDetalhe(item)
                })
            },

            async carregarDetalhe(item) {
                const idItemPesquisa = item?.idLegislacao
                if (!idItemPesquisa) {
                    this.flCarregandoDetalhe = false
                    avisoErro('Não foi possível identificar a legislação selecionada')
                    return
                }

                try {
                    const res = await axios.get(`${urlApi}/LeiComentada/GetDetalhe`, {
                        params: {
                            idItemPesquisa,
                            idLogPesquisa: this.idLogPesquisa,
                        },
                    })

                    if (this.legislacaoSelecionada?.idLegislacao !== idItemPesquisa) {
                        return
                    }

                    if (res.data?.success) {
                        this.detalheLegislacao = res.data.data
                    } else {
                        this.detalheLegislacao = null
                        avisoErro('Não foi possível carregar a legislação')
                    }
                } catch (error) {
                    if (this.legislacaoSelecionada?.idLegislacao !== idItemPesquisa) {
                        return
                    }

                    this.detalheLegislacao = null
                    if (error.response?.data != undefined) {
                        avisoErro(error.response.data)
                    } else {
                        avisoErro('Não foi possível carregar a legislação')
                    }
                } finally {
                    if (this.legislacaoSelecionada?.idLegislacao === idItemPesquisa) {
                        this.flCarregandoDetalhe = false
                    }
                }
            },

            async buscar() {
                this.flCarregando = true

                try {
                    const res = await axios.get(`${urlApi}/LeiComentada/Get`, {
                        params: {
                            dsTermo: this.pesquisa.dsTermo || '',
                        },
                    })

                    if (res.data?.success) {
                        this.lstResultados = res.data.data?.lstLegislacoes || []
                        this.idLogPesquisa = res.data.data?.idLogPesquisa ?? null
                    } else {
                        this.lstResultados = []
                        this.idLogPesquisa = null
                        avisoErro('Não foi possível carregar os registros')
                    }
                } catch (error) {
                    this.lstResultados = []
                    this.idLogPesquisa = null
                    if (error.response?.data != undefined) {
                        avisoErro(error.response.data)
                    } else {
                        avisoErro('Não foi possível carregar os registros')
                    }
                } finally {
                    this.flCarregando = false
                }
            },

            rotuloTipo(tipo) {
                if (!tipo) {
                    return 'Legislação'
                }

                const mapa = {
                    LGFED: 'Federal',
                    LGEST: 'Estadual',
                    LGMUN: 'Municipal',
                    LFSIS: 'Sistema',
                }

                return mapa[tipo] || tipo
            },

            rotuloTipoCompleto(tipo) {
                const mapa = {
                    LGFED: 'Legislação Federal',
                    LGEST: 'Legislação Estadual',
                    LGMUN: 'Legislação Municipal',
                    LFSIS: 'Legislação Sistema S',
                }

                return mapa[tipo] || 'Lei Comentada'
            },

            textoDescricao(texto) {
                if (!texto) {
                    return ''
                }

                return texto
                    .replace(/<[^>]+>/g, ' ')
                    .replace(/&nbsp;/gi, ' ')
                    .replace(/\s+/g, ' ')
                    .trim()
            },

            tipoDaAnotacao(idTipoAnotacao) {
                const lst = (this.detalheLegislacao && this.detalheLegislacao.lstTipoAnotacao) || []
                const tipo = lst.find(x => x.idTipoAnotacao == idTipoAnotacao)
                return tipo ? tipo.cdTipoAnotacao : 1
            },

            htmlGatilhoAnotacao(anotacao) {
                const cdTipo = this.tipoDaAnotacao(anotacao.idTipoAnotacao)
                const reg = anotacao.flRegulamentacao === 'Sim'
                const rotulo = reg ? 'Regulamentação'
                    : cdTipo === 4 ? 'Anotação em vídeo'
                    : cdTipo === 3 ? 'Anotação com arquivo'
                    : 'Anotação'
                const icone = reg ? ICONE_BALANCA : (ICONES_ANOTACAO[cdTipo] || ICONES_ANOTACAO[1])
                const classes = 'ver_anotacao' + (reg ? ' legislacao_anotacao_regulamentacao' : '')

                return `<a class="${classes}" role="button" tabindex="0"
                         data-id="${anotacao.idLegislacaoAnotacao}" data-tipo="${cdTipo}">
                        ${icone}${rotulo}${ICONE_SETA}
                      </a>
                      <span class="legislacao_anotacao${reg ? ' legislacao_anotacao_regulamentacao' : ''}"
                            id="LegislacaoAnotacao-${anotacao.idLegislacaoAnotacao}"></span>`
            },

            slugAnotacaoSollicita(valor) {
                return encodeURIComponent((valor || '').replace(/\?+$/, ''))
            },

            normalizarUrlSollicita(url) {
                if (!url || typeof url !== 'string') {
                    return url || ''
                }

                let parsed
                try {
                    parsed = new URL(url.trim().replace(/&amp;/gi, '&'))
                } catch {
                    return url
                }

                if (!/(^|\.)sollicita\.com\.br$/i.test(parsed.hostname)) {
                    return url
                }

                const path = (parsed.pathname || '').replace(/\/+$/, '') || '/'
                const idNoticia = parsed.searchParams.get('p_idNoticia')
                const idVideo = parsed.searchParams.get('p_idVideo')
                const slug = this.slugAnotacaoSollicita(parsed.searchParams.get('n'))

                if (/^\/Noticia$/i.test(path) && idNoticia) {
                    return `${parsed.origin}/Noticia/${idNoticia}${slug ? `/${slug}` : ''}`
                }

                if (/^\/NoticiaVideo$/i.test(path) && idVideo) {
                    return `${parsed.origin}/Video/${idVideo}${slug ? `/${slug}` : ''}`
                }

                return url
            },

            normalizarLinksAnotacao(texto) {
                if (!texto) {
                    return texto || ''
                }

                return texto.replace(
                    /https?:\/\/(?:www\.)?sollicita\.com\.br\/(?:Noticia|NoticiaVideo)\/?\?[^"'<\s]*/gi,
                    match => this.normalizarUrlSollicita(match)
                )
            },

            dominioAnotacao(url) {
                try {
                    return new URL(url).hostname.replace(/^www\./, '')
                } catch {
                    return url || ''
                }
            },

            nomeArquivoAnotacao(url) {
                if (!url) {
                    return 'arquivo'
                }
                const partes = url.split('/')
                return partes[partes.length - 1] || 'arquivo'
            },

            extensaoArquivoAnotacao(nome) {
                const idx = nome.lastIndexOf('.')
                return idx > 0 ? nome.substring(idx + 1).toUpperCase() : 'ARQ'
            },

            descricaoFormatoAnotacao(nome) {
                const ext = this.extensaoArquivoAnotacao(nome)
                const map = { PDF: 'Documento PDF', DOC: 'Documento Word', DOCX: 'Documento Word', XLS: 'Planilha', XLSX: 'Planilha', PPT: 'Apresentação', PPTX: 'Apresentação', ZIP: 'Arquivo compactado' }
                return map[ext] || `Arquivo ${ext}`
            },

            playerVideoAnotacao(anotacao) {
                if (anotacao.tpExibicaoVideo == 'Local') {
                    return `<video allowfullscreen controls="controls" onkeydown="return false" oncontextmenu="return false">
                        <source src="${anotacao.urlVideo}" type="video/mp4">
                        <source src="${anotacao.urlVideo}" type="video/webm">
                    </video>`
                }
                if (anotacao.tpExibicaoVideo == 'YouTube') {
                    let src = (anotacao.urlVideo || '').replace('https://www.youtube.com/watch?v=', '')
                    src = src.replace('https://youtu.be/', '')
                    if (src.indexOf('&') > 0) {
                        src = src.substring(0, src.indexOf('&'))
                    }
                    return `<iframe src="https://www.youtube.com/embed/${src}?controls=1&disablekb=1&fs=0&mute=1&modestbranding=1&iv_load_policy=3&showinfo=0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
                }
                const src = (anotacao.urlVideo || '').replace('https://vimeo.com/', '')
                return `<iframe src="https://player.vimeo.com/video/${src}" allowfullscreen></iframe>`
            },

            htmlPainelAnotacao(anotacao) {
                const reg = anotacao.flRegulamentacao === 'Sim'
                const cd = this.tipoDaAnotacao(anotacao.idTipoAnotacao)
                let html = `<span class="rotulo">${reg ? 'Norma regulamentadora' : 'Anotação do editor'}</span>`
                html += `<span class="titulo">${anotacao.dsTitulo || ''}</span>`

                if (cd === 1) {
                    html += `<div class="descricao">${this.normalizarLinksAnotacao(anotacao.dsDescricao || '')}</div>`
                }

                if (cd === 2) {
                    const urlLink = this.normalizarUrlSollicita(anotacao.urlLink)
                    html += `<a class="link" href="${urlLink}" target="_blank" rel="noopener">
                           ${ICONE_EXTERNO}Abrir a norma
                           <span class="host">${this.dominioAnotacao(urlLink)}</span>
                         </a>`
                }

                if (cd === 3) {
                    const nome = this.nomeArquivoAnotacao(anotacao.urlUpload)
                    html += `<button type="button" id="downloadAnotacao"
                                 class="anotacao-arquivo anotacao_oculta_imprimir"
                                 data-url="${anotacao.urlUpload}">
                           <span class="fmt">${this.extensaoArquivoAnotacao(nome)}</span>
                           <span>
                             <span id="downloadAnotacaoText">${nome}</span>
                             <span class="peso">${this.descricaoFormatoAnotacao(nome)}</span>
                           </span>
                           <span class="baixar">${ICONE_DOWNLOAD}Baixar</span>
                         </button>
                         <span class="txt-link">Arquivo: ${nome}</span>`
                }

                if (cd === 4) {
                    html += `<div class="anotacao-video anotacao_oculta_imprimir">${this.playerVideoAnotacao(anotacao)}</div>
                         <span class="txt-link">Vídeo: ${anotacao.urlVideo}</span>`
                }

                return html
            },

            cssImpressaoLei() {
                return `<style>
                    body { font-family: Georgia, "Times New Roman", serif; color: #232330; padding: 24px; line-height: 1.6; }
                    h3 { font-size: 18pt; margin: 0 0 8px; }
                    .subtituloLei { color: #5F5F6C; font-size: 11pt; font-style: italic; margin: 0 0 16px; }
                    .aparato-resumo, .ver_anotacao, .modal-footer { display: none !important; }
                    .legislacao_anotacao { display: block !important; margin: 10px 0 18px; padding: 4px 0 4px 14px; border: 0; border-left: 2px solid #999 !important; background: #fff !important; }
                    .rotulo { display: block; font-size: 8pt; letter-spacing: .12em; text-transform: uppercase; font-weight: 700; margin-bottom: 4px; }
                    .titulo { display: block; font-weight: 700; margin-bottom: 6px; }
                    .anotacao_oculta_imprimir { display: none !important; }
                    .txt-link { display: block !important; font-size: 10pt; word-break: break-all; }
                    svg, .ico, .seta { width: 14px !important; height: 14px !important; max-width: 14px !important; max-height: 14px !important; display: inline-block; vertical-align: middle; }
                    .link { display: inline-flex; align-items: center; gap: 6px; font-size: 11pt; color: #232330; text-decoration: none; }
                    .link svg { flex: none; }
                </style>`
            },

            montaAnotacoes() {
                const el = this.$refs.htmlLegislacao
                const dados = this.detalheLegislacao
                if (!el || !dados || !dados.legislacao) {
                    return
                }

                const html = dados.legislacao.htmlLegislacao || ''
                const htmlFormat = html.replace(new RegExp("{{idLegislacaoAnotacao-(.*?)-(.*?)}}", "g"), (match, p1) => {
                    if (!dados.flExibeLeiComentada) {
                        return ''
                    }
                    const obj = (dados.legislacaoAnotacao || []).find(x => x.idLegislacaoAnotacao == p1)
                    return obj ? this.htmlGatilhoAnotacao(obj) : ''
                })

                el.innerHTML = htmlFormat
            },

            handleClick(e) {
                const root = this.$refs.htmlLegislacao
                if (!root) {
                    return
                }

                const gatilho = e.target.closest('.ver_anotacao')
                if (gatilho && root.contains(gatilho)) {
                    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
                        return
                    }
                    e.preventDefault()

                    const id = gatilho.getAttribute('data-id')
                    const painel = root.querySelector('#LegislacaoAnotacao-' + id)
                    if (painel && !painel.innerHTML) {
                        const obj = (this.detalheLegislacao.legislacaoAnotacao || []).find(x => x.idLegislacaoAnotacao == id)
                        if (obj) {
                            painel.innerHTML = this.htmlPainelAnotacao(obj)
                        }
                    }

                    const expandindo = !gatilho.classList.contains('active')
                    gatilho.classList.toggle('active')
                    if (painel) {
                        painel.classList.toggle('active')
                    }

                    if (expandindo && e.isTrusted) {
                        axios.post(`${urlApi}/Log/Registrar`, { cdTipoLog: 'SC_ANOT_LEICOM' }, { showLoading: false }).catch(() => { })
                    }
                    return
                }

                const alvo = e.target.closest('#downloadAnotacao, .anotacao-arquivo')
                if (!alvo) {
                    return
                }
                const value = alvo.getAttribute('data-url')
                if (!value) {
                    return
                }

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${value}`,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', value.split('/').pop())
                    document.body.appendChild(link)
                    link.click()
                })
            },

            imprimir() {
                const root = this.$refs.htmlLegislacao
                if (root) {
                    root.querySelectorAll('.ver_anotacao').forEach(a => {
                        if (!a.classList.contains('active')) {
                            a.click()
                        }
                    })
                }

                const origem = this.$refs.divImprimir
                const destino = this.$refs.conteudoImprimir
                if (!origem || !destino) {
                    return
                }

                destino.innerHTML = origem.innerHTML
                destino.querySelectorAll('.legislacao_anotacao').forEach(el => { el.style.display = 'block' })
                destino.querySelectorAll('.ver_anotacao').forEach(el => { el.style.display = 'none' })
                destino.querySelectorAll('.anotacao_oculta_imprimir').forEach(el => { el.style.display = 'none' })
                destino.querySelectorAll('.txt-link').forEach(el => { el.style.display = 'block' })

                const html = destino.innerHTML + this.cssImpressaoLei()
                const telaImpressao = window.open('about:blank')
                telaImpressao.document.write(html)
                telaImpressao.window.print()
                telaImpressao.window.close()
                destino.innerHTML = ''
            },
        },

        mounted() {
            this.buscar()

            const el = this.$refs.modalLeiComentada
            if (el) {
                el.addEventListener('hidden.bs.modal', () => {
                    this.legislacaoSelecionada = null
                    this.detalheLegislacao = null
                    this.flCarregandoDetalhe = false
                    this.rolou = false
                })
            }
        },

        watch: {
            detalheLegislacao: {
                handler(val) {
                    if (val && val.legislacao) {
                        this.$nextTick(() => this.montaAnotacoes())
                    }
                },
                deep: true,
            },
        },
    })
</script>

<style lang="scss" scoped>
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 2px 0;
    }

    .title-section {
        flex: 0 0 auto;
        text-align: left;
        max-width: 820px;
        min-width: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    .page-container {
        max-width: 1140px;
        margin: 0 auto;
        padding: 24px 16px 48px;
    }

    .search-card {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        border: 1px solid rgba(31, 123, 255, 0.1);
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        padding: 24px;
        margin-bottom: 28px;
    }

    [data-bs-theme="dark"] .search-card {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .search-box {
        position: relative;
        margin-bottom: 20px;
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    .modern-search-input {
        width: 100%;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
        color: #1f2937;
    }

    .modern-search-input:focus {
        outline: none;
        border-color: #2563eb;
        background: white;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    [data-bs-theme="dark"] .modern-search-input {
        background: #111827;
        border-color: #374151;
        color: #e5e7eb;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        min-height: 42px;
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

    .modern-btn-primary:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(31, 123, 255, 0.3);
    }

    .btn-buscar {
        width: 100%;
    }

    .results-header {
        display: flex;
        align-items: baseline;
        gap: 12px;
        flex-wrap: wrap;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e5e7eb;
    }

    [data-bs-theme="dark"] .results-header {
        border-bottom-color: #374151;
    }

    .results-title {
        font-size: 20px;
        font-weight: 800;
        color: #1f2937;
        margin: 0;
        letter-spacing: -0.3px;
    }

    [data-bs-theme="dark"] .results-title {
        color: #f9fafb;
    }

    .results-query {
        font-size: 14px;
        font-weight: 600;
        color: #2563eb;
    }

    .empty-state {
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
        border: 1px dashed #e5e7eb;
        border-radius: 12px;
        padding: 64px 24px;
        text-align: center;
    }

    .empty-state--compact {
        padding: 40px 24px;
    }

    [data-bs-theme="dark"] .empty-state {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .empty-icon {
        color: #cbd5e1;
    }

    .empty-title {
        font-size: 20px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-title {
        color: #f9fafb;
    }

    .empty-description {
        font-size: 15px;
        color: #6b7280;
        margin: 0;
        max-width: 460px;
        line-height: 1.6;
    }

    .empty-hint {
        font-size: 13px;
        font-weight: 600;
        color: #2563eb;
        margin: 8px 0 0;
    }

    .cards-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .result-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        background: #fff;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        padding: 18px 20px;
        cursor: pointer;
        transition: transform .2s, box-shadow .2s, border-color .2s;
    }

    .result-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(31, 123, 255, 0.12);
        border-color: rgba(37, 99, 235, 0.35);
    }

    [data-bs-theme="dark"] .result-card {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

    .result-card__body {
        display: flex;
        flex-direction: column;
        gap: 8px;
        min-width: 0;
        width: 100%;
    }

    .result-card__meta {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
    }

    .result-card__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border-radius: 8px;
        background: rgba(37, 99, 235, 0.1);
        color: #1d4ed8;
        flex-shrink: 0;
        font-size: 14px;
    }

    [data-bs-theme="dark"] .result-card__icon {
        background: rgba(96, 165, 250, 0.16);
        color: #93c5fd;
    }

    .result-badge {
        display: inline-flex;
        align-items: center;
        width: fit-content;
        background: rgba(37, 99, 235, 0.1);
        color: #1d4ed8;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        padding: 4px 12px;
        border-radius: 20px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .result-badge {
        background: rgba(96, 165, 250, 0.16);
        color: #93c5fd;
    }

    .result-card__title {
        font-size: 16px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
        line-height: 1.35;
    }

    [data-bs-theme="dark"] .result-card__title {
        color: #f9fafb;
    }

    .result-card__text {
        font-size: 13px;
        color: #6b7280;
        line-height: 1.6;
        margin: 0;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    [data-bs-theme="dark"] .result-card__text {
        color: #9ca3af;
    }

    @media (max-width: 768px) {
        .modern-header {
            padding: 20px 0;
        }

        .header-content {
            flex-direction: column;
            align-items: flex-start;
        }

        .title-section {
            max-width: 100%;
        }

        .modern-title {
            font-size: 24px;
        }
    }

    @media (max-width: 575px) {
        .search-card {
            padding: 16px;
        }
    }
</style>

<style lang="scss" scoped>
    @import "@/assets/css/lei-comentada/variaveis";
    @import "@/assets/css/lei-comentada/view-legislacao";

    .viewLGFED { @include lei-comentada-view; }

    .md-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        max-height: calc(100vh - 72px);
        overflow: visible;
        background: $sol-papel;
        border-radius: $sol-raio;
        box-shadow: $sol-sombra-modal;
        font-family: $sol-ui;
        color: $sol-texto;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        background: #ffffff !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .btn-close-modern:hover {
        transform: scale(1.05);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        border-color: transparent !important;
    }

    .btn-close-modern:hover svg {
        color: #ffffff;
    }

    .md-header {
        display: flex;
        align-items: center;
        gap: 16px;
        flex: none;
        height: 66px;
        padding: 0 24px;
        background: $sol-papel;
        border-bottom: 1px solid $sol-linha;
        border-radius: $sol-raio $sol-raio 0 0;

        &__id {
            display: flex;
            align-items: center;
            gap: 14px;
            flex: 1;
            min-width: 0;
        }

        &__badge {
            display: inline-flex;
            align-items: center;
            gap: 7px;
            flex: none;
            padding: 5px 10px;
            border: 1px solid $sol-ouro-borda;
            border-radius: 20px;
            background: $sol-ouro-fundo;
            color: $sol-ouro;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.04em;
            text-transform: uppercase;

            i { font-size: 12px; }
        }

        &__title {
            margin: 0;
            font-family: $sol-ui;
            font-size: 17px;
            font-weight: 700;
            color: $sol-texto;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            opacity: 0;
            transform: translateY(6px);
            transition: opacity 0.22s ease, transform 0.22s ease;
        }

        &.rolou &__title { opacity: 1; transform: none; }
    }

    .md-body {
        flex: 1 1 auto;
        overflow: auto;
        background: $sol-papel;
        scroll-behavior: smooth;
        border-radius: 0 0 $sol-raio $sol-raio;
        max-height: calc(100vh - 72px - 66px);
    }

    .md-loading,
    .md-notfound {
        display: grid;
        place-items: center;
        gap: 12px;
        min-height: 320px;
        padding: 40px 24px;
        color: $sol-texto-3;
        font-size: 14.5px;
        text-align: center;
    }

    .md-notfound strong {
        font-family: $sol-ui;
        font-size: 19px;
        font-weight: 700;
        color: $sol-texto;
    }

    .md-loading__spinner {
        width: 38px;
        height: 38px;
        border: 3px solid $sol-linha;
        border-top-color: $sol-ouro;
        border-radius: 50%;
        animation: mdSpin 0.7s linear infinite;
    }

    @keyframes mdSpin {
        to { transform: rotate(360deg); }
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

    [data-bs-theme="dark"] .btn-close-modern svg {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .btn-close-modern:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    }

    [data-bs-theme="dark"] .md-wrapper {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        color: #e5e7eb;
        box-shadow: 0 24px 80px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .md-header {
        background: #1f2937;
        border-bottom-color: #374151;
    }

    [data-bs-theme="dark"] .md-header__title {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .md-header__badge {
        background: rgba(96, 165, 250, 0.16);
        border-color: rgba(96, 165, 250, 0.28);
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .md-body {
        background: #111827;
    }

    [data-bs-theme="dark"] .md-loading,
    [data-bs-theme="dark"] .md-notfound {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .md-notfound strong {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .md-loading__spinner {
        border-color: #374151;
        border-top-color: #3b82f6;
    }

    @media (max-width: 900px) {
        .md-wrapper { max-height: calc(100vh - 32px); }

        .md-header {
            height: auto;
            padding: 14px 16px;
            flex-wrap: wrap;
            gap: 10px;

            &__title { white-space: normal; font-size: 16px; }
        }
    }

    @media print {
        .btn-close-modern,
        .md-header__badge { display: none !important; }

        .md-wrapper {
            display: block;
            max-width: none;
            max-height: none;
            border-radius: 0;
            box-shadow: none;
        }

        .md-header {
            height: auto;
            padding: 0 0 8px;
            margin-bottom: 18px;
            border-bottom: 1px solid #000;
        }

        .md-header__title {
            opacity: 1 !important;
            transform: none !important;
            white-space: normal;
            font-size: 15px;
        }

        .md-body { overflow: visible; background: #fff; max-height: none; }
    }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    :deep(.btn-manual-tool) {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        min-height: 42px;
        background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%) !important;
        color: #fff !important;
        border: none !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    :deep(.btn-manual-tool:hover) {
        background: linear-gradient(135deg, #4b5563 0%, #374151 100%) !important;
        transform: translateY(-2px);
    }
</style>

<style lang="scss">
    @import "@/assets/css/lei-comentada/variaveis";

    .modal-lei-comentada.modal {
        overflow: visible;
    }

    .modal-lei-comentada .modal-dialog {
        width: 90%;
        max-width: 90vw;
        overflow: visible;
        margin: 36px auto;
    }

    .modal-lei-comentada .modal-content {
        background: transparent;
        border: 0;
        box-shadow: none;
        overflow: visible;
    }

    .modal-lei-comentada .modal-body {
        padding: 0;
        overflow: visible;
    }

    body:has(.modal-lei-comentada.show) .modal-backdrop {
        background: $sol-scrim;
        opacity: 1 !important;
    }

    
</style>
